import { ConfigSchema } from '../types';

const rawEnv = {
    mode: process.env.REACT_APP_MODE_ENV,
    apiUrl: process.env.REACT_APP_API_URL,
    requestTimeout: process.env.REACT_APP_REQUEST_TIMEOUT,
    storage: process.env.REACT_APP_STORAGE,
    bucket: process.env.REACT_APP_BUCKET,
    browser: process.env.REACT_APP_BROWSER, 
};

const parsedConfig = ConfigSchema.safeParse(rawEnv);

if(!parsedConfig.success) {
    console.error('Invalid environment variables:');
    const issues = parsedConfig.error.issues
        .map(issue => `  ${issue.path.join('.')}: ${issue.message}`)
        .join('\n');
    console.error(issues);
    throw new Error('Application configuration error');
}

export const config = parsedConfig.data;

export type Config = typeof config;